var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "terminology-listing" }, [
    _c(
      "div",
      { staticClass: "container" },
      _vm._l(_vm.groupedItems, function (items, letter) {
        return _c("div", { key: letter, staticClass: "inner" }, [
          _c("h2", [_vm._v(_vm._s(letter))]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(items, function (item) {
              return _c("li", { key: item.id, staticClass: "item" }, [
                _c("h5", [_vm._v(_vm._s(item.title))]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "body",
                  domProps: {
                    innerHTML: _vm._s(item.content || "No content available"),
                  },
                }),
              ])
            }),
            0
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }